import { action } from "@ember/object";
import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import type Features from "ember-feature-flags";
import type { IntlService } from "ember-intl";
import type SessionService from "ember-simple-auth/services/session";
import { formats } from "parog-web/ember-intl";
import type AnalyticsService from "parog-web/services/analytics";
import type NativeAppService from "parog-web/services/native-app";
import missingMessage from "parog-web/utils/intl/missing-message";
import translationsForFrFr from "virtual:ember-intl/translations/fr-fr";

export default class ApplicationRoute extends Route {
  @service declare analytics: AnalyticsService;
  @service declare features: Features;
  @service declare intl: IntlService;
  @service declare nativeApp: NativeAppService;
  @service requestManager;
  @service declare router: RouterService;
  @service declare session: SessionService;

  constructor(...args: ConstructorParameters<typeof Route>) {
    super(...args);
    this.analytics.startRouterTracking();
  }

  override async beforeModel() {
    this.intl.setFormats(formats);
    this.intl.addTranslations("fr-fr", translationsForFrFr);
    this.intl.setOnMissingTranslation(missingMessage);
    this.intl.setLocale("fr-fr");
    await this.session.setup();

    this.nativeApp.setup();
  }

  @action
  // @ts-expect-error: error return type incoherent with ember documentation
  error(error: any) {
    // Check if the error coming from a requestManager is a 401
    const isUnauthorizedFromRequestManager = error?.status == 401;
    // Check if the error coming from an adapter is a 401
    const isUnauthorizedFromAdapter =
      error?.errors && ["401", "403"].includes(error.errors[0].status);
    if (isUnauthorizedFromRequestManager || isUnauthorizedFromAdapter) {
      this.router.replaceWith("medics-web.login");
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}
